var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-dots-separator"},[_c('div',{staticClass:"ui-dots-separator__filler"}),(_vm.text !== null)?_c('div',{staticClass:"ui-dots-separator__text",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e(),_c('div',{staticClass:"ui-dots-separator__filler"})])
}
var staticRenderFns = []

export { render, staticRenderFns }